import React from "react";
import LoginInformation from "../../../components/Login/LoginInformation";

const LoginInformationPage = () => {
   return <LoginInformation />;
};

export default LoginInformationPage;
